<template>
  <div class="whole-vehicle-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'WholeVehicleIndex'
}
</script>

<style lang="less" scoped>
.whole-vehicle-container {
  padding: 20px;
  height: 100%;
}
</style>